// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"d16dce33","403":"e6754506","800":"b25bb427"}[chunkId] + ".chunk.js";
};